/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export enum ShiftSegmentReturnCodes {
  Success = 0,
  AssemblySelected = 1,
  FieldFabSelected = 2,
  Error = 3
}
